<template>
  <section class="dev-logos">
    <p class="title">
      Dev Brands
    </p>

    <div class="flex flex-wrap w-full">
      <img
        v-for="(brand, i) in devBrands"
        :key="i"
        :src="brand.logoImageUrl"
        class="dev-logo"
        @click="$emit('brand-selected', brand)"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: "DevBrands",
  data() {
    return {
      devBrands: [
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-tower.png",
          primaryColor: "#37a56d",
          secondaryColor: "#3b3d3c",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-leaf.png",
          primaryColor: "#029d85",
          secondaryColor: "#bedc7b",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-volicity-9.png",
          primaryColor: "#fd8518",
          secondaryColor: "#e91b8f",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-treva.png",
          primaryColor: "#ed3178",
          secondaryColor: "#38b6d7",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-nira.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-u-mark.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-tvit.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-muszica.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-kyan.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-towers.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-solaytic.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-ideaa.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-earth.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-earth-2.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-hex-lab.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-hexa.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-lighting.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-aven.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-fox-hub.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-fox-hub-2.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-fossa.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-circle.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-cod-lab.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-asgardia.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logomark-a-lab.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-aven.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-amara.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-asgardia.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-atica.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-circle.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-code-lab.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-earth-2.0.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-earth-2.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-fossa.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-fox-hub.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-goldline.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-hex-lab.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-hexa.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-ideaa.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-kanba.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-kyan.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-lighting.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-liva.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-muzica-2.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-muzica.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-nirastate.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-solaytic.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-treva.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-utosia-2.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-utosia.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-velocity-9.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-zoo-tv.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/files/dev-logos/logotype-ztos.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        //
        {
          logoImageUrl:
            "https://s3.us-west-2.amazonaws.com/promo-services-dev-promouploadbucket-gzui0hqg3wme/files%2F2020-09-23%2Ffile-46a69102-9fb0-4ca8-be74-0894042baba5-logo-16.png",
          primaryColor: "#E3073C",
          secondaryColor: "#06E07F",
        },
        {
          logoImageUrl:
            "https://s3.us-west-2.amazonaws.com/promo-services-dev-promouploadbucket-gzui0hqg3wme/files%2F2020-09-23%2Ffile-0b67dda8-ca2b-4cf9-904f-f02080999508-logo-15.png",
          primaryColor: "#17CF97",
          secondaryColor: "#fafafa",
        },
        {
          logoImageUrl:
            "https://s3.us-west-2.amazonaws.com/promo-services-dev-promouploadbucket-gzui0hqg3wme/files%2F2020-09-23%2Ffile-180e6ebd-2edc-4b66-8fac-639eb0762210-logo-14.png",
          primaryColor: "#68DBFF",
          secondaryColor: "#FF7917",
        },
        {
          logoImageUrl:
            "https://s3.us-west-2.amazonaws.com/promo-services-dev-promouploadbucket-gzui0hqg3wme/files%2F2020-09-23%2Ffile-cb3b09cf-716a-4b45-a949-401e39c789c8-logo-13.png",
          primaryColor: "#FF7917",
          secondaryColor: "#442781",
        },
        {
          logoImageUrl:
            "https://s3.us-west-2.amazonaws.com/promo-services-dev-promouploadbucket-gzui0hqg3wme/files%2F2020-09-23%2Ffile-5c758c75-ef01-4237-baa6-5afef37b2bab-logo-11.png",
          primaryColor: "#394149",
          secondaryColor: "#fafafa",
        },
        {
          logoImageUrl:
            "https://s3.us-west-2.amazonaws.com/promo-services-dev-promouploadbucket-gzui0hqg3wme/files%2F2020-03-02%2Ffile-c87d2eb6-ccec-478b-8303-6a8049dcf7d3-soho-mum-logo.png",
          primaryColor: "#F1969B",
          secondaryColor: "#585757",
        },
        {
          logoImageUrl:
            "https://s3.us-west-2.amazonaws.com/promo-services-dev-promouploadbucket-gzui0hqg3wme/files%2F2020-03-03%2Ffile-e6e11646-2eb5-4e32-a4a4-26f644d996c5-carrington-road-logo.png",
          primaryColor: "#2BC0AC",
          secondaryColor: "#5C5749",
        },
        {
          logoImageUrl:
            "https://s3.us-west-2.amazonaws.com/promo-services-dev-promouploadbucket-gzui0hqg3wme/files%2F2020-03-03%2Ffile-ba7a3330-f126-48b9-85dd-58f2d1f51c1c-gattuso-logo.png",
          primaryColor: "#404040",
          secondaryColor: "#FFFFFF",
        },
        {
          logoImageUrl:
            "https://s3.us-west-2.amazonaws.com/promo-services-dev-promouploadbucket-gzui0hqg3wme/files%2F2020-03-03%2Ffile-01fc3d38-e765-468d-8bbe-f20fbba750df-gazleme-logo.png",
          primaryColor: "#21D99B",
          secondaryColor: "#303030",
        },
        {
          logoImageUrl:
            "https://s3.us-west-2.amazonaws.com/promo-services-dev-promouploadbucket-gzui0hqg3wme/files%2F2020-03-03%2Ffile-d7e745ea-7900-40a5-a6bd-03db6a6c3ac9-honngers-logo.png",
          primaryColor: "#00276B",
          secondaryColor: "#FFD009",
        },
        {
          logoImageUrl:
            "https://s3.us-west-2.amazonaws.com/promo-services-dev-promouploadbucket-gzui0hqg3wme/files%2F2020-03-03%2Ffile-562202b7-a264-4143-93cb-147e830a9b7a-why-dee.png",
          primaryColor: "#4D1C59",
          secondaryColor: "#FED7EC",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/sample-logos/af.png",
          primaryColor: "#5eb5f9",
          secondaryColor: "#204b6d",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/sample-logos/bridal.png",
          primaryColor: "#f2a292",
          secondaryColor: "#f9e4e0",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/sample-logos/missa.png",
          primaryColor: "#e7a4af",
          secondaryColor: "#000000",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/sample-logos/franco.png",
          primaryColor: "#CF1141",
          secondaryColor: "#ffffff",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/sample-logos/bondi.png",
          primaryColor: "#FFC900",
          secondaryColor: "#151f27",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/sample-logos/adam.png",
          primaryColor: "#FF0067",
          secondaryColor: "#ffffff",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/sample-logos/vendi.png",
          primaryColor: "#7b294d",
          secondaryColor: "#545454",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/sample-logos/organica.png",
          primaryColor: "#FFDE59",
          secondaryColor: "#8DDB59",
        },
        {
          logoImageUrl:
            "https://promo-services-dev-promouploadbucket-gzui0hqg3wme.s3-us-west-2.amazonaws.com/sample-logos/deewhy.png",
          primaryColor: "#414765",
          secondaryColor: "#414765",
        },
      ],
    };
  },
};
</script>

<style scoped>
.title {
  @apply mb-4 text-support text-sm font-bold;
}

.dev-logo {
  @apply shadow-md rounded cursor-pointer p-2 mr-5 h-auto;
  object-fit: contain;
  width: 89px;

  &:hover {
    transform: scale(1.1);
  }
}
</style>
